
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 126 126"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#e5e7e8","d":"M0 0h126v126H0z"}}),_c('path',{attrs:{"d":"M71.8 67.4c6.1 0 11 4.9 11 11v4.4c0 1.2-1 2.2-2.2 2.2-1.2 0-2.2-1-2.2-2.2v-4.4c0-3.6-3-6.6-6.6-6.6H54.2c-3.6 0-6.6 3-6.6 6.6v4.4c0 1.2-1 2.2-2.2 2.2s-2.2-1-2.2-2.2v-4.4c0-6.1 4.9-11 11-11h17.6zM63 41c6.1 0 11 4.9 11 11s-4.9 11-11 11-11-4.9-11-11 4.9-11 11-11zm0 4.4c-3.6 0-6.6 3-6.6 6.6 0 3.6 3 6.6 6.6 6.6s6.6-3 6.6-6.6c0-3.6-3-6.6-6.6-6.6z","fill":"#fff"}})])
          )
        }
      }
    